import type { ErrorCode, ApiErrorEnvelope } from '@ember/shared';

export class ApiError extends Error {
  readonly status: number;
  readonly code: ErrorCode;
  readonly details: Record<string, unknown> | undefined;

  constructor(status: number, code: ErrorCode, message: string, details?: Record<string, unknown>) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }

  static async fromResponse(res: Response): Promise<ApiError> {
    let envelope: ApiErrorEnvelope | undefined;
    try {
      envelope = (await res.json()) as ApiErrorEnvelope;
    } catch {
      /* not JSON */
    }
    if (envelope?.error) {
      return new ApiError(res.status, envelope.error.code, envelope.error.message, envelope.error.details);
    }
    return new ApiError(res.status, 'HTTP_ERROR', `HTTP ${res.status}`);
  }
}

export function isApiError(err: unknown): err is ApiError {
  return err instanceof ApiError;
}

type UnauthenticatedListener = () => void;
const unauthenticatedListeners = new Set<UnauthenticatedListener>();

export function onUnauthenticated(fn: UnauthenticatedListener): () => void {
  unauthenticatedListeners.add(fn);
  return () => unauthenticatedListeners.delete(fn);
}

export function emitUnauthenticated(): void {
  for (const listener of unauthenticatedListeners) {
    try {
      listener();
    } catch {
      /* swallow */
    }
  }
}
